var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E8F0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6312 27.5C24.0437 27.5 23.5406 27.2906 23.1219 26.8719C22.7031 26.4531 22.4937 25.95 22.4937 25.3625C22.4937 25.275 22.5031 25.1719 22.5219 25.0531C22.5406 24.9344 22.5688 24.825 22.6063 24.725L16.925 21.425C16.7375 21.6375 16.5062 21.8094 16.2312 21.9406C15.9562 22.0719 15.675 22.1375 15.3875 22.1375C14.8 22.1375 14.2969 21.9281 13.8781 21.5094C13.4594 21.0906 13.25 20.5875 13.25 20C13.25 19.4 13.4594 18.8938 13.8781 18.4813C14.2969 18.0688 14.8 17.8625 15.3875 17.8625C15.675 17.8625 15.95 17.9187 16.2125 18.0312C16.475 18.1438 16.7125 18.3062 16.925 18.5187L22.6063 15.2563C22.5688 15.1688 22.5406 15.0688 22.5219 14.9563C22.5031 14.8438 22.4937 14.7375 22.4937 14.6375C22.4937 14.0375 22.7031 13.5312 23.1219 13.1188C23.5406 12.7063 24.0437 12.5 24.6312 12.5C25.2312 12.5 25.7375 12.7063 26.15 13.1188C26.5625 13.5312 26.7687 14.0375 26.7687 14.6375C26.7687 15.225 26.5625 15.7281 26.15 16.1469C25.7375 16.5656 25.2312 16.775 24.6312 16.775C24.3437 16.775 24.0656 16.7281 23.7969 16.6344C23.5281 16.5406 23.3 16.3875 23.1125 16.175L17.4312 19.325C17.4562 19.425 17.4781 19.5406 17.4969 19.6719C17.5156 19.8031 17.525 19.9125 17.525 20C17.525 20.0875 17.5156 20.1813 17.4969 20.2812C17.4781 20.3812 17.4562 20.4812 17.4312 20.5812L23.1125 23.8063C23.3 23.6313 23.5187 23.4906 23.7687 23.3844C24.0188 23.2781 24.3062 23.225 24.6312 23.225C25.2312 23.225 25.7375 23.4312 26.15 23.8438C26.5625 24.2563 26.7687 24.7625 26.7687 25.3625C26.7687 25.95 26.5625 26.4531 26.15 26.8719C25.7375 27.2906 25.2312 27.5 24.6312 27.5Z",
    fill: "#070C3D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.4b57d83de90af27377d9433a8b1d4910.svg";
export { ForwardRef as ReactComponent };